module.exports = __webpack_public_path__ + "img-front/register/kinesis-five.4a4412b0.svg";